<template>    
    <div class="row">
        <div class="col">
            <h2 class="titre">Ajout Service d'urgence</h2>
        </div>
    </div>
    <ModifierChamps ref="modifierChamps" :urgence="urgence" :isModifier="false"/>
    <ButtonBar @fermer="fermer"
     @ajouter="ajouter" :isSauvegardeEnCours="isSauvegardeEnCours"/>
     <DialogConfirmation ref="dialogConfirmation" />
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import ButtonBar from '../../../components/dossier/Ajouter/ButtonBarUrgence.vue'
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsUrgence.vue'
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue'

export default {
    components: {
        ButtonBar,
        ModifierChamps,
        DialogConfirmation
    },
    data() {
        return {
            isSauvegardeEnCours: false,
        };
    },
    computed: {
        ...mapGetters({
            jeton: 'cardex/jeton',
      profil: 'cardex/profil',
            urgence: 'urgence/urgence'
        })
    },    
    beforeMount() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
        this.$root.$refs.breadcrumbComp.ajout("Ajouter un Urgence");
        this.$store.dispatch('urgence/resetUrgenceStoredAction', {
            cleDossier: this.$route.params.cleDossier,
            siteDossier: this.$route.params.siteDossier
        });
        this.isRechercheDataLoading = false;
    },
    methods: {
        ajouter() {
            this.isSauvegardeEnCours = true;
            this.$store.commit('urgence/UPDATE_URGENCE',this.$refs.modifierChamps.getUrgenceLocal());            
            this.$store.dispatch('urgence/ajouterUrgenceAction', {
                cle: this.$route.params.cle,
                site: this.$route.params.site,
            }).then((res) =>{
                this.isSauvegardeEnCours = false;
                this.$root.$refs.messagesComp.messagesList = res.data.messages;
                if (res?.data?.messages.length == 0) {
                    this.$router.push({ name: 'dossierModifier', params: {cle: this.$route.params.cleDossier, site: this.$route.params.siteDossier}});
                }
            });
        },    
        fermer() {
            this.$root.$refs.breadcrumbComp.rediriger();           
        },         
    },
    beforeRouteLeave (to, from, next) {
        return this.$refs.dialogConfirmation.confirmer(next, this.urgence,
        this.$refs.modifierChamps.getUrgenceLocal());
    },  
};
</script>
